import Cookies from 'universal-cookie';
import type { CookieSetOptions } from 'universal-cookie';

const cookies = new Cookies();

const hasForstokCookieDomain = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = window.location.hostname.toLowerCase();

  return hostname === 'forstok.com' || hostname.endsWith('.forstok.com');
};

export const getScopedCookieOptions = (expires?: Date): CookieSetOptions => {
  if (import.meta.env.DEV || !hasForstokCookieDomain()) {
    return {
      path: '/',
      expires,
    };
  }

  return {
    path: '/',
    domain: '.forstok.com',
    expires,
  };
};

export const getTokenCookieOptions = (expires?: Date): CookieSetOptions => {
  if (
    import.meta.env.DEV ||
    !hasForstokCookieDomain() ||
    (typeof window !== 'undefined' && window.location.protocol !== 'https:')
  ) {
    return {
      path: '/',
      expires,
    };
  }

  return {
    path: '/',
    sameSite: 'none',
    secure: true,
    domain: '.forstok.com',
    expires,
  };
};

export const removeCookieEverywhere = (name: string) => {
  const removalOptions: CookieSetOptions[] = [
    { path: '/' },
    getScopedCookieOptions(),
    getTokenCookieOptions(),
  ];

  const uniqueRemovalOptions = removalOptions.filter((option, index, allOptions) => {
    const signature = JSON.stringify(option);
    return allOptions.findIndex((candidate) => JSON.stringify(candidate) === signature) === index;
  });

  uniqueRemovalOptions.forEach((option) => {
    cookies.remove(name, option);
  });
};

export default cookies;
